import React from 'react';
export const ProductSection = () => {
  return <section id="product" className="w-full py-12 bg-amber-50" data-id="element-188">
      <div className="container mx-auto px-4" data-id="element-189">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-6 text-center" data-id="element-190">
          Introducing America's Best-Selling Probiotic Chew For Dogs*
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-191">
          <div className="w-full md:w-1/2" data-id="element-192">
            <p className="text-green-900/80 mb-6" data-id="element-193">
              Unlike typical probiotics that die in stomach acid, The Daily
              Foundation Chew™ uses a revolutionary three-system approach that
              addresses your dog's gut health at its root:
            </p>
            <div className="mb-4" data-id="element-194">
              <h3 className="text-xl font-bold text-green-900 mb-2" data-id="element-195">
                System 1: The Ancestral Core Blend™
              </h3>
              <p className="text-green-900/80" data-id="element-196">
                Our freeze-dried, grass-fed organ meats (liver, heart, kidney)
                provide the exact nutrients your dog's ancestors thrived on –
                nutrients completely missing from modern kibble. These
                "ancestral activators" help restore your dog's natural digestive
                balance.
              </p>
            </div>
            <div className="mb-4" data-id="element-197">
              <h3 className="text-xl font-bold text-green-900 mb-2" data-id="element-198">
                System 2: Resilient Gut Flora
              </h3>
              <p className="text-green-900/80" data-id="element-199">
                We use soil-based probiotics (B. subtilis & B. coagulans) that
                form protective spores, allowing them to survive stomach acid
                and actually reach your dog's gut alive. Combined with organic
                spirulina as a prebiotic, they crowd out harmful bacteria and
                restore healthy balance.
              </p>
            </div>
            <div className="mb-6" data-id="element-200">
              <h3 className="text-xl font-bold text-green-900 mb-2" data-id="element-201">
                System 3: Inflammation Defense
              </h3>
              <p className="text-green-900/80" data-id="element-202">
                Green-lipped mussel and CurcuVET® (29x more bioavailable than
                regular turmeric) calm the system-wide inflammation that starts
                in an unhealthy gut and spreads throughout the body.
              </p>
            </div>
            <p className="text-green-900 font-bold mb-6" data-id="element-203">
              This isn't just another probiotic – it's a complete gut
              restoration system based on your dog's ancestral needs.
            </p>
            <a href="#results" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-204">
              LEARN MORE
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-205">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ifjSj8V71HFMzWQurzDujD/Frame_182_1.webp" alt="Before and after comparison showing a dog's skin condition improvement with The Daily Foundation Chew" className="rounded-lg w-full" data-id="element-206" />
          </div>
        </div>
      </div>
    </section>;
};